import { render, staticRenderFns } from "./ProductSynchronousRecording.vue?vue&type=template&id=1dd8f795&scoped=true"
import script from "./ProductSynchronousRecording.vue?vue&type=script&lang=js"
export * from "./ProductSynchronousRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8f795",
  null
  
)

export default component.exports